import { render, staticRenderFns } from "./shareTree.vue?vue&type=template&id=6464d2cb&scoped=true"
import script from "./shareTree.vue?vue&type=script&lang=js"
export * from "./shareTree.vue?vue&type=script&lang=js"
import style0 from "./shareTree.vue?vue&type=style&index=0&id=6464d2cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6464d2cb",
  null
  
)

export default component.exports